import { __decorate } from "tslib";
// import md5 from 'js-md5';
import { Component, Vue } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import * as dd from 'dingtalk-jsapi';
import Navigation from '@/components/Navigation.vue'; // @ is an alias to /src
import { BcUtils } from '@/classes/BcClasses';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
let Home = class Home extends Vue {
    constructor() {
        super();
        this.snackbar = new CBcSnackbar();
        this.username = '';
        this.password = '';
        this.loginLoading = false;
        this.showPass = false;
        this.drawer = null;
        this.left = false;
        this.dingLoading = false;
        this.alter = {
            visible: false,
            text: '',
        };
        this.dlgForgetCode = {
            visible: false,
            text: '',
        };
        this.dingUserInfo = {};
        this.isDingUserRegister = false;
        this.isDingMobileExists = false;
        this.isDingEmailExists = false;
        this.isDingOrgEmailExists = false;
        const that = this;
        this.dlgRegister = {
            visible: false,
            loading: false,
            showPass: false,
            showNewPass: false,
            title: '',
            text: '',
            form: {
                username: '',
                name: '',
                alias: '',
                phone: '',
                employeeNo: '',
                password: '',
                password2: '',
                email: '',
            }
        };
        this.dlgForget = {
            visible: false,
            loading: false,
            fetchingCode: false,
            showPass: false,
            showNewPass: false,
            title: '',
            text: '',
            form: {
                username: '',
                emailCode: '',
                alias: '',
                phone: '',
                employeeNo: '',
                password: '',
                password2: '',
            }
        };
        this.valid = false;
    }
    async created() {
        const that = this;
        try {
            const routeQuery = that.$router.currentRoute.query || {};
            const loginType = routeQuery && routeQuery.type || Vue.filter('checkClientBrowser')();
            const isBrowserDT = /dingtalk/i.test(Vue.filter('checkClientBrowser')());
            const category = routeQuery && routeQuery.category || (isBrowserDT && 'webapp') || '';
            if (/dingtalk/i.test(loginType)) {
                try {
                    that.setAppType(loginType);
                    that.dingLoading = true;
                    const corpidRst = await that.axios.patch('/api/apps/dingtalk/corpid', { secret: 'broadcare', type: 'webapp' });
                    dd.ready(() => {
                        // dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
                        dd.runtime.permission.requestAuthCode({
                            corpId: corpidRst.data.corpid,
                            // @ts-ignore
                            onSuccess: (result) => {
                                that.axios.get('/api/users/login/app', { params: { appType: 'dingtalk', category: category, code: result && result.code } }).then((res) => {
                                    that.dingUserInfo = res.data.result;
                                    that.isDingUserRegister = res.data.isRegister;
                                    that.isAccountExists = res.data.isAccountExists; // 新增：账号已存在
                                    that.isDingMobileExists = res.data.isMobileExists;
                                    that.isDingEmailExists = res.data.isEmailExists;
                                    that.isDingOrgEmailExists = res.data.isOrgEmailExists;
                                    const loginTypeText = that.isDingMobileExists ? '手机号' : that.isDingEmailExists ? '邮箱' : that.isDingOrgEmailExists ? '企业邮箱' : '';
                                    const loginTypeValue = that.isDingMobileExists || that.isDingEmailExists || that.isDingOrgEmailExists;
                                    if (!that.isDingUserRegister) {
                                        const existField = (that.isDingMobileExists || that.isDingEmailExists || that.isDingOrgEmailExists);
                                        that.dingLoading = false;
                                        if (!existField && isBrowserDT) {
                                            that.loginByApp();
                                        }
                                        else {
                                            that.alter.visible = true;
                                            that.alter.text = existField ? `当前用户${loginTypeText}【${loginTypeValue}】已存在于系统中，您可使用该${loginTypeText}的用户账号进行登录绑定` : '当前用户未绑定，请登录已注册用户进行绑定';
                                        }
                                    }
                                    else {
                                        // 已注册用户，直接调用 loginByApp 跳过密码验证
                                        that.loginByApp();
                                    }
                                }).catch((e) => {
                                    const errMsg = (e && e.response && e.response.data && (e.response.data.error || e.response.data.result)) || (e && (e.message || e.result || e.info || e.error)) || '未知错误';
                                    that.snackbar.error('用户认证失败: ' + errMsg);
                                    that.dingLoading = false;
                                    console.log('error of get server dingtalk api:', e);
                                });
                            },
                            onFail: (err) => {
                                that.dingLoading = false;
                                console.log('get dd result error:', err);
                                that.snackbar.error('钉钉服务接口信息获取失败：\n' + JSON.stringify(err));
                            }
                        });
                    });
                }
                catch (e) {
                    that.dingLoading = false;
                    that.snackbar.error('钉钉服务请求失败:\n' + (e && e.toString()));
                }
            }
        }
        catch (e) {
            that.snackbar.error(`处理登录页面接口出错:${e}`);
            console.log('error of handle login:', e);
        }
    }
    loginByApp() {
        const that = this;
        that.loginHandle({ withAppUserIdRegister: true });
    }
    async loginHandle(op) {
        const that = this;
        that.loginLoading = true;
        let appUserInfo = {};
        if (that.isDingTalk) {
            that.dingLoading = true;
            const dingUsrId = that.dingUserInfo && that.dingUserInfo.userid || '';
            appUserInfo = { isRegister: that.isDingUserRegister, withBind: 'dingtalk', phone: that.dingUserInfo.mobile, employeeNo: that.dingUserInfo.jobnumber, ...that.dingUserInfo, department: (that.dingUserInfo.department || []).map((v) => v.name).join(',') };
            appUserInfo['isDingMobileExists'] = that.isDingMobileExists;
            appUserInfo['isDingEmailExists'] = that.isDingEmailExists;
            appUserInfo['isDingOrgEmailExists'] = that.isDingOrgEmailExists;
            appUserInfo['dingtalk'] = dingUsrId;
            appUserInfo['appUserId'] = dingUsrId;
            appUserInfo['withAppUserIdRegister'] = (op && op.withAppUserIdRegister);
            delete appUserInfo.userid;
        }
        that.axios.post('/api/users/login', {
            ...appUserInfo,
            dingUserInfo: that.dingUserInfo,
            username: (op && op.withAppUserIdRegister) ? appUserInfo.dingtalk : that.username,
            password: (op && op.withAppUserIdRegister) ? (BcUtils.random(3) + String(Date.now()).substr(-4, 4)) : that.password,
            routerQ: that.$router.currentRoute.query,
            routerP: that.$router.currentRoute.params,
        })
            .then(async (res) => {
            that.dingLoading = false;
            that.loginLoading = false;
            const usrId = res.data.userId;
            let curPris = {};
            try {
                curPris = (await that.axios.get(`/api/privileges/users/${usrId}`)).data.result || {};
            }
            catch (e) {
                console.log('error of get current user privileges:', e);
                const errMsg = (e && e.response && e.response.data && (e.response.data.error || e.response.data.result)) || (e && (e.message || e.result || e.info || e.error)) || '未知错误';
                that.snackbar.error('获取用户权限出错: ' + errMsg);
            }
            that.$store.commit('setToken', res.data.token);
            that.$store.commit('login', Object.assign(res.data, { username: that.username, role: res.data['userRole'], privileges: curPris }));
            that.$router.push({
                path: that.$router.currentRoute && that.$router.currentRoute.query
                    && that.$router.currentRoute.query.redirect || '/'
            });
        })
            // @ts-ignore
            .catch((e) => {
            const errMsg = (e && e.response && e.response.data && (e.response.data.error || e.response.data.result)) || (e && (e.message || e.result || e.info || e.error)) || e.toString() || '登录失败';
            that.snackbar.error(errMsg);
            that.dingLoading = false;
            that.loginLoading = false;
        });
    }
    userKeyDown(event) {
        const that = this;
        if (event.key === 'Enter' && that.username) {
            that.$refs.passField.focus();
        }
    }
    loginKeyDown(event) {
        const that = this;
        if (event.key === 'Enter') {
            if (!that.username)
                return that.snackbar.warn('请输入用户名');
            if (!that.password)
                return that.snackbar.warn('请输入密码');
            that.loginHandle();
        }
    }
    displayRegister() {
        const that = this;
        // that.dlgRegister.title = '修改用户' + this.username + '密码'
        that.dlgRegister.title = '用户注册';
        that.dlgRegister.text = '';
        that.dlgRegister.form.username = that.username;
        that.dlgRegister.form = {
            email: '',
            alias: '',
            username: '',
            name: '',
            phone: '',
            employeeNo: '',
            password: '',
            password2: '',
        };
        that.dlgRegister.visible = true;
    }
    displayForgetPass() {
        const that = this;
        // that.dlgRegister.title = '修改用户' + this.username + '密码'
        that.dlgForget.title = '忘记密码';
        that.dlgForget.text = '';
        that.dlgForget.form.username = that.username;
        that.dlgForget.form = {
            email: '',
            alias: '',
            username: '',
            emailCode: '',
            phone: '',
            employeeNo: '',
            password: '',
            password2: '',
        };
        that.dlgForget.visible = true;
    }
    registerHandle() {
        const that = this;
        that.dlgRegister.loading = true;
        const body = JSON.parse(JSON.stringify(that.dlgRegister.form));
        if (body.password2 !== body.password) {
            that.snackbar.warn('用户密码两次输入不一致');
            return;
        }
        if (!body.phone)
            delete body['phone'];
        delete body['password2'];
        delete body['employeeNo']; // TODO. 后期添加
        that.axios.post('/api/users/register', body)
            .then((res) => {
            console.log('reset user pass success:', res.data);
            that.dlgRegister.loading = false;
            that.dlgRegister.visible = false;
            that.dlgRegister.form = {
                email: '',
                alias: '',
                username: '',
                name: '',
                phone: '',
                employeeNo: '',
                password: '',
                password2: '',
            };
            that.snackbar.success('用户注册成功');
            // that.$refs.userRegisterForm.reset()
        })
            .catch((e) => {
            console.log('reset user pass error:', e);
            that.dlgRegister.loading = false;
            that.snackbar.error(e && (e.info || e.error || e.result) || '用户注册失败');
        });
    }
    forgetPassHandle() {
        const that = this;
        that.axios.post('/api/users/password/forget/' + that.dlgForget.form.emailCode, { userName: that.dlgForget.form.username, password: that.dlgForget.form.password })
            .then((res) => {
            that.dlgForget.visible = false;
            that.dlgForget.form = {
                alias: '',
                username: '',
                name: '',
                phone: '',
                employeeNo: '',
                password: '',
                password2: '',
            };
            // that.dlgForgetCode.text = res && res.data && res.data.result
            that.snackbar.success('用户密码重置成功');
        })
            .catch((e) => {
            console.log('reset user pass error:', e);
            // that.dlgForget.fetchingCode = false
            that.snackbar.error(e && (e.info || e.error || e.result) || '用户重置密码失败');
        });
    }
    getForgetPassCode() {
        const that = this;
        that.dlgForget.fetchingCode = true;
        that.axios.post('/api/email/user/forgetpass', { userName: that.dlgForget.form.username })
            .then((res) => {
            console.log('email:', res);
            that.dlgForget.fetchingCode = false;
            // that.dlgForget.visible = false
            // that.dlgForget.form = {
            //   alias: '',
            //   username: '',
            //   name: '',
            //   phone: '',
            //   employeeNo: '',
            //   password: '',
            //   password2: '',
            // }
            that.dlgForgetCode.visible = true;
            that.dlgForgetCode.text = res && res.data && res.data.email;
            that.snackbar.success('验证码已发送');
        })
            .catch((e) => {
            console.log('reset user pass error:', e);
            that.dlgForget.fetchingCode = false;
            that.snackbar.error(e && (e.info || e.error || e.result) || '用户重置密码失败');
        });
    }
};
__decorate([
    Getter
], Home.prototype, "appType", void 0);
__decorate([
    Getter
], Home.prototype, "isThirdApp", void 0);
__decorate([
    Getter
], Home.prototype, "isSrvTestEnv", void 0);
__decorate([
    Getter
], Home.prototype, "isDingTalk", void 0);
__decorate([
    Mutation
], Home.prototype, "setAppType", void 0);
Home = __decorate([
    Component({
        data: () => ({}),
        mounted() {
            // this.test();
        },
        computed: {
            user() {
                this.$store.commit('checkLogin');
            },
        },
        props: {
            source: String,
        },
        components: {
            BcSnackbar,
            Navigation,
        },
        methods: {},
    })
], Home);
export default Home;
